import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { getPartnershipsImages } from "../../network";
import { toastError } from "../../helpers/toasters";
import { baseUrl } from "../../services";

export default function Partnerships() {
  const [partnersLogo, setPartnersLogo] = useState([]);

  const { dir } = useSelector((state) => state.language);
  const { t } = useTranslation();

  useEffect(() => {
    getPartnershipsImages(
      (success) => {
        setPartnersLogo(success.data);
      },
      (error) => {
        toastError(error.message || "An error occurred");
      }
    );
  }, []);

  return (
    <section dir={dir} className="partnerships">
      <header className="merchant__header d-flex justify-content-center align-items-center">
        <div>
          <h1 className="text-center green-text">{t("nav.partnership")}</h1>
          <p className="mb-0 fw-500 text-white text-center">
            {t("partnership.description")}
          </p>
        </div>
      </header>

      <div className="partnerships__image-container">
        {partnersLogo?.map((logo) => {
          return (
            <img
              className={[7, 3].includes(logo.id) ? "paymob" : undefined}
              src={baseUrl + logo.logo}
              key={logo.id}
              alt="partner-logo"
              loading="lazy"
            />
          );
        })}
      </div>
    </section>
  );
}
